var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsB2BIconReportBarChart2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.16,
    height: 137.02,
    viewBox: "0 0 100.16 137.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.35,1.57H3.83v5H77.35Zm23.38,22.35L79.11,2.3,75.58,5.84,97.2,27.45Zm.74,112.17V25.68h-5V136.09Zm-97.64,2.5H99v-5H3.83ZM1.33,4.07v132h5V4.07Zm76,0L79.09,2.3a2.48,2.48,0,0,0-1.76-.73ZM99,25.68h2.5a2.47,2.47,0,0,0-.74-1.76Zm0,110.41v2.5a2.5,2.5,0,0,0,2.5-2.5Zm-95.14,0H1.33a2.5,2.5,0,0,0,2.5,2.5Zm0-132V1.59a2.5,2.5,0,0,0-2.5,2.5Z",
    transform: "translate(-1.31 -1.57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.35,28.62H99v-5H77.35ZM74.83,4.07V26.12h5v-22ZM99,28.62a2.5,2.5,0,0,0,0-5Zm-21.62-2.5h-2.5a2.5,2.5,0,0,0,2.5,2.5Zm2.5-22a2.5,2.5,0,0,0-5,0Z",
    transform: "translate(-1.31 -1.57)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.04,
    y: 22.06,
    width: 8.78,
    height: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 22.06,
    width: 26.01,
    height: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 33.01,
    width: 44.1,
    height: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.83,117.39V102h-5v15.4Zm10.78-2.5H46.35v5H59.63ZM57.11,102v15.4h5V102Zm-10.78,2.5h13.3v-5H46.35Zm0,12.9h-2.5a2.5,2.5,0,0,0,2.5,2.5Zm13.28,0v2.5a2.5,2.5,0,0,0,2.5-2.5Zm0-15.4h2.5a2.5,2.5,0,0,0-2.5-2.5Zm-13.28,0v-2.5a2.5,2.5,0,0,0-2.5,2.5Z",
    transform: "translate(-1.31 -1.57)",
    fill: "red"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.74,117.39V91.94h-5v25.45Zm10.78-2.5H23.24v5H36.52Zm-2.5-23v25.45h5V91.94Zm-10.78,2.5H36.52v-5H23.24Zm0,23h-2.5a2.5,2.5,0,0,0,2.5,2.5Zm13.28,0v2.5a2.5,2.5,0,0,0,2.5-2.5Zm0-25.45H39a2.5,2.5,0,0,0-2.5-2.5Zm-13.28,0v-2.5a2.5,2.5,0,0,0-2.5,2.5Z",
    transform: "translate(-1.31 -1.57)",
    fill: "red"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72,117.39V71.2H67v46.23Zm10.78-2.5H69.46v5H82.74ZM80.24,71.2v46.23h5V71.2ZM69.46,73.7H82.74v-5H69.46Zm0,43.73H67a2.5,2.5,0,0,0,2.5,2.5Zm13.28,0v2.5a2.5,2.5,0,0,0,2.5-2.5Zm0-46.23h2.5a2.5,2.5,0,0,0-2.5-2.5Zm-13.28,0V68.7A2.5,2.5,0,0,0,67,71.2Z",
    transform: "translate(-1.31 -1.57)",
    fill: "red"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.15,114.89H17v5H88.15Zm-71.11,0a2.5,2.5,0,0,0,0,5Zm71.11,5a2.5,2.5,0,0,0,0-5Z",
    transform: "translate(-1.31 -1.57)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsB2BIconReportBarChart2);
export default __webpack_public_path__ + "static/media/ws-b2b-icon-report_bar_chart-2.d3481b25f19a48afce6530146faf2b51.svg";
export { ForwardRef as ReactComponent };